// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setup-guide-popup {
  background: rgba(255, 255, 255, 0.8980392157);
  position: relative;
  z-index: 100;
  top: -3.5rem;
}
.setup-guide-popup .setup-guide-heading {
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0 0.5rem 0;
}
.setup-guide-popup div {
  height: max-content;
  position: relative;
  background-color: #fff;
}
.setup-guide-popup .setup-guide-heading h3 {
  font-weight: 400;
  line-height: 30px;
  color: #3a3a3a;
}
.setup-guide-popup .setup-guide-video {
  position: absolute;
  max-width: 676px;
  width: 100%;
  padding: 2.5rem 3rem 2.5rem 3rem;
  left: 50%;
  transform: translate(-50%, -100%);
  z-index: 999;
  top: 0;
  height: max-content;
}
.setup-guide-popup svg.pause-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.launchDialog {
  background: rgba(255, 255, 255, 0.8980392157);
  position: relative;
  z-index: 100;
  top: -3.5rem;
}

.videoDialog {
  position: relative;
}
.videoDialog .close-btn {
  width: 100%;
  text-align: end;
  margin-top: -1.665vw;
}
.videoDialog .features-list {
  display: block;
  margin-top: 1.11vw;
}
.videoDialog .features-list li {
  list-style: inside;
  font-size: 0.8325vw;
  font-weight: 400;
  line-height: 1.25vw;
}
.videoDialog .video-content {
  padding: 1.11vw 2.22vw;
}
.videoDialog .title {
  font-size: 0.901875vw;
  font-weight: 500;
  line-height: 1.24875vw;
  color: #0f0f0f;
}
.videoDialog .desc {
  font-size: 0.8325vw;
  font-weight: 400;
  line-height: 1.24875vw;
  color: #3a3a3a;
  margin: 1.11vw 0;
}
.videoDialog .customise-btn {
  background-color: #ee3a24;
  border-radius: 3px;
  padding: 1.11vw 2.775vw;
  border: none;
  color: #fff;
  cursor: pointer;
}
.videoDialog .customise-btn {
  background-color: #ee3a24;
  border-radius: 3px;
  padding: 0.8325vw 3.33vw;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 0.901875vw;
  font-weight: 500;
  line-height: 1.24875vw;
}
.videoDialog .customise-btn span {
  position: relative;
  left: 0.775vw;
  top: 0.2775vw;
}
.videoDialog svg.close-dialog-icon {
  position: absolute;
  top: 1.332vw;
  text-align: end;
  float: right;
  right: 0.9435vw;
  z-index: 10;
  cursor: pointer;
}
.videoDialog svg.pause-icon {
  position: absolute;
  top: 54%;
  left: 53%;
  transform: translate(-50%, -50%);
}
.videoDialog svg.pause-icon:hover {
  filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg) brightness(87%) contrast(116%);
}

.videoPopup {
  position: relative;
  z-index: 100;
}
.videoPopup .video {
  position: absolute;
  max-width: 676px;
  width: 100%;
  top: 0;
  left: 50%;
  transform: translate(-50%, -100%);
  z-index: 3;
  display: flex;
  align-items: center;
  height: max-content;
}
.videoPopup .video div {
  height: max-content;
  position: relative;
  background-color: #fff;
}
.videoPopup svg.pause-icon {
  position: absolute;
  top: 32%;
  left: 54%;
  transform: translate(-50%, -50%);
}
.videoPopup svg.close-dialog-icon {
  position: absolute;
  top: 1.2rem;
  text-align: end;
  float: right;
  right: 0.85rem;
  z-index: 10;
}
.videoPopup .title {
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: #0f0f0f;
}
.videoPopup .desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #3a3a3a;
  margin: 1rem 0;
}
.videoPopup .customise-btn {
  background-color: #ee3a24;
  border-radius: 3px;
  padding: 1rem 2.5rem;
  border: none;
  color: #fff;
  cursor: pointer;
}
.videoPopup .customise-btn {
  background-color: #ee3a24;
  border-radius: 3px;
  padding: 0.75rem 3rem;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
}
.videoPopup .customise-btn span {
  position: relative;
  left: 0.25rem;
  top: 0.25rem;
}

.videoPopup > div {
  width: 100%;
  height: 100%;
  z-index: 2;
}

div.setUpGuideModal svg.pause-icon {
  position: absolute;
  top: 45%;
  left: 52%;
  transform: translate(-50%, -50%);
}

div.setUpGuideModal svg.pause-icon:hover {
  filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg) brightness(87%) contrast(116%);
}

div.setUpGuideModal .MuiDialog-paper {
  padding: 1rem 2rem;
}

div.setUpGuideModal .MuiDialogTitle-root {
  padding: 0.25rem 0;
}`, "",{"version":3,"sources":["webpack://./src/style/components/popup/VideoPopup.scss"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AACF;AAAE;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;AAEJ;AAAE;EACE,mBAAA;EACA,kBAAA;EACA,sBAAA;AAEJ;AAAE;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;AAEJ;AACE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EAEA,gCAAA;EACA,SAAA;EACA,iCAAA;EACA,YAAA;EACA,MAAA;EACA,mBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AADJ;;AAIA;EACE,6CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AADF;;AAGA;EACE,kBAAA;AAAF;AACE;EACE,WAAA;EACA,eAAA;EACA,oBAAA;AACJ;AACE;EACE,cAAA;EACA,kBAAA;AACJ;AACE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AACJ;AAEE;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;AAGE;EACE,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AADJ;AAIE;EACE,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;AAHJ;AAKE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAHJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAJJ;AAME;EACE,gGAAA;AAJJ;;AASA;EACE,kBAAA;EACA,YAAA;AANF;AAQE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,iCAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AANJ;AAYI;EACE,mBAAA;EACA,kBAAA;EACA,sBAAA;AAVN;AAcE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAZJ;AAeE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;AAbJ;AAgBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAdJ;AAiBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAfJ;AAkBE;EACE,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAhBJ;AAmBE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAjBJ;AAoBE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AAlBJ;;AAsBA;EACE,WAAA;EACA,YAAA;EAEA,UAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AApBF;;AAsBA;EACE,gGAAA;AAnBF;;AAsBA;EACE,kBAAA;AAnBF;;AAqBA;EACE,kBAAA;AAlBF","sourcesContent":[".setup-guide-popup {\n  background: #ffffffe5;\n  position: relative;\n  z-index: 100;\n  top: -3.5rem;\n  .setup-guide-heading {\n    display: flex;\n    justify-content: space-between;\n    margin: 0.5rem 0 0.5rem 0;\n  }\n  div {\n    height: max-content;\n    position: relative;\n    background-color: #fff;\n  }\n  .setup-guide-heading h3 {\n    font-weight: 400;\n    line-height: 30px;\n    color: #3a3a3a;\n  }\n\n  .setup-guide-video {\n    position: absolute;\n    max-width: 676px;\n    width: 100%;\n    // background: #FFFFFFE5;\n    padding: 2.5rem 3rem 2.5rem 3rem;\n    left: 50%;\n    transform: translate(-50%, -100%);\n    z-index: 999;\n    top: 0;\n    height: max-content;\n  }\n\n  svg.pause-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n}\n.launchDialog {\n  background: #ffffffe5;\n  position: relative;\n  z-index: 100;\n  top: -3.5rem;\n}\n.videoDialog {\n  position: relative;\n  .close-btn {\n    width: 100%;\n    text-align: end;\n    margin-top: -1.665vw;\n  }\n  .features-list {\n    display: block;\n    margin-top: 1.11vw;\n  }\n  .features-list li {\n    list-style: inside;\n    font-size: 0.8325vw;\n    font-weight: 400;\n    line-height: 1.25vw;\n  }\n  .video-content {\n    padding: 1.11vw 2.22vw;\n  }\n  .title {\n    font-size: 0.901875vw;\n    font-weight: 500;\n    line-height: 1.24875vw;\n    color: #0f0f0f;\n  }\n\n  .desc {\n    font-size: 0.8325vw;\n    font-weight: 400;\n    line-height: 1.24875vw;\n    color: #3a3a3a;\n    margin: 1.11vw 0;\n  }\n\n  .customise-btn {\n    background-color: #ee3a24;\n    border-radius: 3px;\n    padding: 1.11vw 2.775vw;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n  }\n\n  .customise-btn {\n    background-color: #ee3a24;\n    border-radius: 3px;\n    padding: 0.8325vw 3.33vw;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    font-size: 0.901875vw;\n    font-weight: 500;\n    line-height: 1.24875vw;\n  }\n\n  .customise-btn span {\n    position: relative;\n    left: 0.775vw;\n    top: 0.2775vw;\n  }\n  svg.close-dialog-icon {\n    position: absolute;\n    top: 1.332vw;\n    text-align: end;\n    float: right;\n    right: 0.9435vw;\n    z-index: 10;\n    cursor: pointer;\n  }\n\n  svg.pause-icon {\n    position: absolute;\n    top: 54%;\n    left: 53%;\n    transform: translate(-50%, -50%);\n  }\n  svg.pause-icon:hover {\n    filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg)\n      brightness(87%) contrast(116%);\n  }\n}\n\n.videoPopup {\n  position: relative;\n  z-index: 100;\n\n  .video {\n    position: absolute;\n    max-width: 676px;\n    width: 100%;\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -100%);\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    height: max-content;\n    // video{\n    //     border-radius: 0.5rem;\n    //     overflow: hidden;\n    // }\n\n    div {\n      height: max-content;\n      position: relative;\n      background-color: #fff;\n    }\n  }\n\n  svg.pause-icon {\n    position: absolute;\n    top: 32%;\n    left: 54%;\n    transform: translate(-50%, -50%);\n  }\n\n  svg.close-dialog-icon {\n    position: absolute;\n    top: 1.2rem;\n    text-align: end;\n    float: right;\n    right: 0.85rem;\n    z-index: 10;\n  }\n\n  .title {\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 18px;\n    color: #0f0f0f;\n  }\n\n  .desc {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px;\n    color: #3a3a3a;\n    margin: 1rem 0;\n  }\n\n  .customise-btn {\n    background-color: #ee3a24;\n    border-radius: 3px;\n    padding: 1rem 2.5rem;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n  }\n\n  .customise-btn {\n    background-color: #ee3a24;\n    border-radius: 3px;\n    padding: 0.75rem 3rem;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 18px;\n  }\n\n  .customise-btn span {\n    position: relative;\n    left: 0.25rem;\n    top: 0.25rem;\n  }\n}\n\n.videoPopup > div {\n  width: 100%;\n  height: 100%;\n  // position: absolute;\n  z-index: 2;\n}\n\ndiv.setUpGuideModal svg.pause-icon {\n  position: absolute;\n  top: 45%;\n  left: 52%;\n  transform: translate(-50%, -50%);\n}\ndiv.setUpGuideModal svg.pause-icon:hover {\n  filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg)\n    brightness(87%) contrast(116%);\n}\ndiv.setUpGuideModal .MuiDialog-paper {\n  padding: 1rem 2rem;\n}\ndiv.setUpGuideModal .MuiDialogTitle-root {\n  padding: 0.25rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
